/*
 * API URL FOR ALL AJAX CALL
 */
export const API_URL = "https://agents.israel.travel/server/";

export const APP_NAME = "ac";
export const APP_VERSION = "1.0.0";



// WEBPACK FOOTER //
// ./src/config.js